import { useCallback, useContext } from 'react';

import { TIME_PERIOD_PREDICATES } from '../constants';
import { BuyTicketsLayoutContext } from '../layouts/BuyTicketsLayout';
import { selectTotalQuantity, useAppSelector } from '../store';

export const useGetAvailableTimeSlot = () => {
  const { dayAvailabilities } = useContext(BuyTicketsLayoutContext);
  const checkoutTotalQuantity = useAppSelector(selectTotalQuantity);

  // Segments all availabilities into morning, afternoon and evening
  const getAvailableTimeSlot = useCallback(
    (timePeriod?: number) => {
      // timePeriod: whether the availability is for the morning, afternoon or evening
      const timeSlot =
        dayAvailabilities?.find((timeSlot) => {
          return (
            Number(timeSlot.availability) >= checkoutTotalQuantity &&
            TIME_PERIOD_PREDICATES[timePeriod ?? 0](timeSlot.startRaw.hours)
          );
        }) ?? null;

      return timeSlot;
    },
    [checkoutTotalQuantity, dayAvailabilities],
  );

  const getTimePeriodByTimeSlot = (hours: number) => {
    if (hours < 12) return 0;
    if (hours < 17) return 1;
    return 2;
  };

  return { getAvailableTimeSlot, getTimePeriodByTimeSlot };
};
